import axios from 'axios';
import { API_CONFIG, buildApiUrl } from '../config/apiConfig';

class OrdersApiService {
  constructor() {
    this.baseUrl = API_CONFIG.BASE_URL;
    this.prefix = API_CONFIG.API_PREFIX;
    this.ordersEndpoint = '/orders';
  }

  async fetchOrders() {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORDERS || this.ordersEndpoint);
    const token = localStorage.getItem('auth_token');
    const headers = { ...API_CONFIG.DEFAULT_HEADERS };
    if (token && token !== 'null' && token !== 'undefined') {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(url, { headers, timeout: API_CONFIG.TIMEOUT.DEFAULT });
    if (!Array.isArray(response.data)) {
      throw new Error('Resposta da API inválida: esperado um array de ordens');
    }
    return response.data;
  }

  // Mapeia um item da API para o formato interno usado pelo sistema
  mapOrder(order) {
    // Suporta tanto chaves já no padrão atual quanto um esquema típico de API
    return {
      'Ord.Ser': order['Ord.Ser'] ?? order.id ?? order.numero ?? null,
      'Data Inclusao': order['Data Inclusao'] ?? order.created_at ?? order.data_inclusao ?? null,
      'Cliente': order['Cliente'] ?? order.cliente ?? null,
      'service_order_customer_id': order['service_order_customer_id'] ?? order.CodigoCliente ?? order.cliente_id ?? order.codigo_cliente ?? order.customer_id ?? null,
      'Descrição': order['Descrição'] ?? order.descricao ?? null,
      'Problema': order['Problema'] ?? order.problema ?? null,
      'Tipo de Ord.Serviço': order['Tipo de Ord.Serviço'] ?? order.tipo_servico ?? null,
      'Posição': order['Posição'] ?? order.posicao ?? order.status ?? null,
      'Técnico': order['Técnico'] ?? order.tecnico ?? null,
      'Atendente': order['Atendente'] ?? order.atendente ?? null,
      'Faturada': order['Faturada'] ?? order.faturada ?? null,
      'Cobertura': order['Cobertura'] ?? order.cobertura ?? null,
      'Vlr.cobrado ser': order['Vlr.cobrado ser'] ?? order.valor_servico ?? order.valorServico ?? null,
      'Vlr.cobrado mat': order['Vlr.cobrado mat'] ?? order.valor_material ?? order.valorMaterial ?? null,
      'Local entrega': order['Local entrega'] ?? order.local_entrega ?? null,
      'Marca/modelo': order['Marca/modelo'] ?? order.marca_modelo ?? null,
      'Fabricante': order['Fabricante'] ?? order.fabricante ?? null,
    };
  }
}

const ordersApiService = new OrdersApiService();
export default ordersApiService;
